// The per-thread model switch (src/threadModel.js). One compact select with the
// price in the label, saved per writer per thread; every surface renders it
// in its header and passes the choice to the proxy as `modelOverride`.
import { useEffect, useState } from 'react';
import { MODEL_CHOICES, getThreadModel, setThreadModel } from './threadModel.js';

export default function ModelSwitch({ userId, threadType, threadId, compact = false, onChange, style }) {
  const [model, setModel] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    let alive = true;
    if (!userId || !threadId) { setModel(''); return undefined; }
    getThreadModel(userId, threadType, threadId).then(m => { if (alive) setModel(m); });
    return () => { alive = false; };
  }, [userId, threadType, threadId]);
  if (!userId || !threadId) return null;
  const current = MODEL_CHOICES.find(c => c.id === model) || MODEL_CHOICES[0];
  const change = async (e) => {
    const next = e.target.value;
    setSaving(true);
    const ok = await setThreadModel(userId, threadType, threadId, next);
    setSaving(false);
    if (ok) { setModel(next); if (onChange) onChange(next); }
  };
  return (
    <label title={current.note} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: compact ? '11px' : '12px', opacity: saving ? 0.6 : 1, ...(style || {}) }} onClick={e => e.stopPropagation()}>
      <span aria-hidden="true">⚡</span>
      <select value={model} onChange={change} disabled={saving} aria-label="Model for this thread"
        style={{ background: 'transparent', color: 'inherit', border: '1px solid var(--ds-accent-a33, #c6282833)', borderRadius: '6px', padding: compact ? '3px 4px' : '4px 6px', fontSize: 'inherit', maxWidth: compact ? '150px' : '220px' }}>
        {MODEL_CHOICES.map(c => <option key={c.id || 'default'} value={c.id}>{compact && c.id ? c.label : c.label}</option>)}
      </select>
    </label>
  );
}
